import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Divider,
  List, Container,
  ListItem,
  ListItemIcon,
  ListItemText,
  TextField,
  ToggleButtonGroup,
  ToggleButton,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import PropTypes from 'prop-types';
import Badge from '@mui/material/Badge';

import axios from "axios";
import { CREATE_ORDER, ENQUIRY_SUBSCRIPTION_PLAN, ENQUIRY_SUBSCRIPTION_PLAN_ACTIVE, PAYMENT_LINK_CREATE_ORDER, PAYMENT_LINK_SAVE_PAYMENT_INFO, PAYMENT_LINK_VERIFY_TOKEN, SAVE_PAYMENT_INFO, START_FREE_TRAIL, SUBSCRIPTION_HISTORY } from "../../services/apiRoutes";
import { genericPost } from "../../services/authServices";
import { useNavigate } from "react-router-dom";
import CustomMaster from "../../components/common/CustomMaster";
import { genericGet } from "../../services/apiServices";
import CustomPrefixSuffixField from "../../components/common/CustomPrefixSuffixField";
import CustomButton from "../../components/common/CustomButton";
import { useParams } from "react-router-dom";


const GeneratePaymentLink = ({ isFirstTimeLogin, setValue, setId }) => {
  const { token } = useParams();

  const navigate = useNavigate();
  const [additionalUsers, setAdditionalUsers] = useState(0);
  const [additionalCompany, setAdditionalCompany] = useState(0);
  const [selectedPlanId, setSelectedPlanId] = useState(1);
  const [selectedCurrency, setSelectedCurrency] = useState(233);
  const [latestSubscription, setLatestSubscription] = useState(null);
  const [subscriptionType, setSubscriptionType] = useState("yearly");
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeButton, setActiveButton] = useState('International');
  const [isLinkValid, setIsLinkValid] = useState(null); // null | true | false
  const [verifying, setVerifying] = useState(true);
  const [verifiedOrg, setVerifiedOrg] = useState(null);

  const [message, setMessage] = useState({
    message: "",
    status: "",
    type: "",
  });

  useEffect(() => {
    fetchSubscriptionPlans(1);
  }, []);

  useEffect(() => {
    if (subscriptionPlans.length > 0) {
      updateTotalPrice(subscriptionType, additionalUsers, additionalCompany);
    }
  }, [subscriptionPlans]);


  const selectedPlan = subscriptionPlans.length > 0 ? subscriptionPlans[0] : null;
  const monthlyPerUserPrice = selectedPlan ? parseFloat(selectedPlan.perMonthAmount) : 0;
  const yearlyBasePrice = selectedPlan ? parseFloat(12 * selectedPlan.baseAmount) : 0;
  const monthlyBasePrice = selectedPlan ? parseFloat(selectedPlan.baseAmount) : 0;
  const yearlyPerUserPrice = selectedPlan ? parseFloat(12 * (selectedPlan.perMonthAmount)) : 0;
  const companyPerYear = selectedPlan ? parseFloat(12 * (selectedPlan.companyPerMonth)) : 0;
  const companyPerMonth = selectedPlan ? parseFloat(selectedPlan.companyPerMonth) : 0;
  const currencySymbol = selectedPlan ? selectedPlan.currencySymbol : '';
  const planName = selectedPlan ? selectedPlan.planName : '';

  const plans = [
    {
      planId: "1",
      title: "Yearly",
      planTime: "12 Month",
      discountContant: "Discounted Price (10% OFF)",
      price: `${planName}`,
      features: [
        `Basic Subcription Fee ${currencySymbol}${yearlyBasePrice}`,
        `Includes 2 users and 1 company free`,
        `Additional Per User ${currencySymbol}${yearlyPerUserPrice}`,
        `Additional Per Company ${currencySymbol}${companyPerYear}`,
      ],
    },
    {
      planId: "2",
      title: "Monthly",
      planTime: "1 Month",
      discountContant: "",
      price: `${planName}`,
      features: [
        `Basic Subcription Fee ${currencySymbol}${monthlyBasePrice}`,
        `Includes 2 users and 1 company free`,
        `Additional Per User ${currencySymbol}${monthlyPerUserPrice}`,
        `Additional Per Company ${currencySymbol}${companyPerMonth}`,
      ],
    },
  ];

  const [totalPrice, setTotalPrice] = useState(yearlyBasePrice);

  const fetchSubscriptionPlans = async (planId = 1) => {
    setLoading(true);
    try {
      const payload = {
        plan: planId,
      };

      const response = await genericPost(ENQUIRY_SUBSCRIPTION_PLAN_ACTIVE, payload);

      if (response.data.success && Array.isArray(response.data.SubscriptionPlan)) {
        const planData = response.data.SubscriptionPlan.map((plan, index) => ({
          id: plan.subscriptionPlanId,
          index: (index + 1).toString().padStart(2, '0'),
          planName: plan.PlanType?.planName || "",
          baseAmount: plan.baseAmount,
          currencySymbol: plan.currencyList?.currency_symbol || "",
          perMonthAmount: plan.perMonthAmount,
          companyPerMonth: plan.companyPerMonth,
          planActiveDate: plan.planActiveDate,
          planExpiredDate: plan.planExpiredDate || '',
          subscriptionPlanId: plan.subscriptionPlanId || "",
          planActiveStatus: plan.planActiveStatus || "",

        }));
        setSubscriptionPlans(planData);
      } else {
        setError('No subscription plans found');
      }
    } catch (error) {
      setError('Error fetching subscription plans');
      console.error('Error fetching subscription plans:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleClose = () => {
    setMessage((prev) => ({ ...prev, status: false }))
    if (isFirstTimeLogin) {
      navigate('/app/dashboard')
    }
  };

  const handleUserChange = (event) => {
    const users = parseInt(event.target.value, 10) || 1;
    setAdditionalUsers(users);
    updateTotalPrice(subscriptionType, users, additionalCompany);
  };

  const handleCompanyChange = (event) => {
    const companies = parseInt(event.target.value, 10) || 1;
    setAdditionalCompany(companies);
    updateTotalPrice(subscriptionType, additionalUsers, companies);
  };

  // const updateTotalPrice = (type, users, companies = additionalCompany) => {
  //   if (type === "yearly") {
  //     setTotalPrice(yearlyBasePrice + ((1 * users) * yearlyPerUserPrice) + ((1 * companies) * companyPerYear));
  //   } else {
  //     setTotalPrice(monthlyBasePrice + ((1 * users) * monthlyPerUserPrice) + ((1 * companies) * companyPerMonth));
  //   }
  // };

  const updateTotalPrice = (type, users, companies = additionalCompany) => {
    let baseAmount = type === "yearly" ? yearlyBasePrice : monthlyBasePrice;
    let userAmount = type === "yearly"
      ? (users * yearlyPerUserPrice)
      : (users * monthlyPerUserPrice);
    let companyAmount = type === "yearly"
      ? (companies * companyPerYear)
      : (companies * companyPerMonth);

    let total = baseAmount + userAmount + companyAmount;

    if (type === "yearly") {
      total = total - (total * 0.10); // Apply 10% discount
    }

    setTotalPrice(total);
  };


  const handleSubscriptionTypeChange = (event, newType) => {
    if (newType) {
      setSubscriptionType(newType);
      updateTotalPrice(newType, additionalUsers);
    }
  };

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };
  // const today = new Date();
  // const startDate = today.toISOString().split("T")[0];
  // const formatDate = (date) => date.toISOString().split("T")[0];
  // const monthDate = formatDate(new Date(today.setMonth(today.getMonth() + 3)));
  // const yearDate = formatDate(new Date(today.setFullYear(today.getFullYear() + 1)));

  const today = new Date();
  const startDate = today.toISOString().split("T")[0];
  const formatDate = (date) => date.toISOString().split("T")[0];
  // Add 30 days to current date for monthDate
  const monthDate = formatDate(new Date(today.getTime() + 30 * 24 * 60 * 60 * 1000));
  // Add 365 days to current date for yearDate
  const yearDate = formatDate(new Date(today.getTime() + 365 * 24 * 60 * 60 * 1000));

  console.log("Month Date (30 days later):", monthDate);
  console.log("Year Date (365 days later):", yearDate);


  const handlePayment = async () => {
    const isRazorpayLoaded = await loadRazorpayScript();
    if (!isRazorpayLoaded) {
      alert("");
      setMessage({
        status: true,
        message:
          "Failed to load Razorpay SDK. Please check your internet connection.",
        type: "error",
      });
      return;
    }

    try {
      const response = await genericPost(PAYMENT_LINK_CREATE_ORDER, { amount: totalPrice });
      if (response.error) {
        throw new Error(response.error || "Error creating order.");
      }

      const orderData = response.data;
      const endDate = subscriptionType === "yearly" ? yearDate : monthDate;

      const options = {
        key: "rzp_test_dD0jhbnTbrfcD3",
        amount: totalPrice * 100,
        currency: "USD",
        name: "Exim CRM",
        description: `${subscriptionType.charAt(0).toUpperCase() + subscriptionType.slice(1)
          } Subscription Payment`,
        order_id: orderData.id,
        handler: async (paymentResponse) => {
          setMessage({
            status: true,
            message: ` Payment ID: ${paymentResponse.razorpay_payment_id}`,
            type: "success",
          });
          setValue && setValue(2)

          setId && setId(paymentResponse.razorpay_payment_id)
          const paymentInfo = {
            userId: verifiedOrg?.userId,
            companyId: verifiedOrg?.companyId,
            orgId: verifiedOrg?.orgId,

            orderId: orderData.id,
            razorpayPaymentId: paymentResponse.razorpay_payment_id,
            razorpayOrderId: paymentResponse.razorpay_order_id,
            razorpaySignature: paymentResponse.razorpay_signature,
            subscriptionId: subscriptionType === "yearly" ? "1" : "2",
            totalPrice: totalPrice,
            totalCompany: 1 + parseInt(additionalCompany),
            totalUsers: 2 + parseInt(additionalUsers),
            startDate: startDate,
            endDate: endDate,
            plan: selectedPlanId,
            currency: selectedCurrency,
          };

          const saveResponse = await genericPost(
            PAYMENT_LINK_SAVE_PAYMENT_INFO,
            paymentInfo
          );
          if (saveResponse.status === 201) {
          } else {
          }
        },
        prefill: {
          name: "Test User",
          email: "user@example.com",
        },
        theme: {
          color: "#3399cc",
        },
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    } catch (error) {
      setMessage({
        status: true,
        message: "Failed to create order. Please try again later.",
        type: "error",
      });
    }
  };



  const handleStartFreeTrail = async () => {
    let payload = {
      freeTrialStartedOn: new Date(),
      subscriptionStartedOn: null,
      totalUsers: 1
    }
    try {
      const response = await genericPost(START_FREE_TRAIL, payload);
      if (response.status == 201 || response.status == 200) {
        setMessage({
          open: true,
          text: "Free trial Started",
          type: "success",
        });
        navigate("/app/dashboard")
      }
    } catch (error) {
      setMessage({
        open: true,
        text: 'Something went wrong',
        type: "error",
      });
    }
  }
  const totalUserAmount = subscriptionType === "yearly"
    ? (parseInt(additionalUsers || 0) * yearlyPerUserPrice)
    : (parseInt(additionalUsers || 0) * monthlyPerUserPrice);

  const totalCompanyAmount = subscriptionType === "yearly"
    ? (parseInt(additionalCompany || 0) * companyPerYear)
    : (parseInt(additionalCompany || 0) * companyPerMonth);

  const discountAmount = subscriptionType === "yearly"
    ? ((yearlyBasePrice + totalUserAmount + totalCompanyAmount) * 0.10)
    : 0;


  useEffect(() => {
    const verifyToken = async () => {
      try {
        const response = await axios.get(
          PAYMENT_LINK_VERIFY_TOKEN(token)
        );

        // ✅ 200 OK
        if (response.status === 200 && response.data.success) {
          const { organization } = response.data;

          setIsLinkValid(true);
          setVerifiedOrg(organization);


        } else {
          setIsLinkValid(false);
        }

      } catch (error) {
        // ❌ 401 or any invalid token
        if (error.response?.status === 401) {
          setIsLinkValid(false);
        } else {
          setIsLinkValid(false);
        }
      } finally {
        setVerifying(false);
      }
    };

    verifyToken();
  }, [token]);

  if (verifying) {
    return (
      <Box textAlign="center" mt={5}>
        <Typography>Verifying payment link...</Typography>
      </Box>
    );
  }
  if (isLinkValid === false) {
    return (
      <Box textAlign="center" mt={8}>
        <ErrorOutlineIcon sx={{ fontSize: 80, color: "red" }} />
        <Typography variant="h5" mt={2}>
          Payment link expired or invalid
        </Typography>
        <Typography color="textSecondary" mt={1}>
          Please contact support or request a new payment link.
        </Typography>
      </Box>
    );
  }


  return (
    <>
      {/*  @@@@@@@@@@@@@@@@@@@*/}

      <Box sx={{ padding: 1, textAlign: "center" }}>
        <Box
          display="flex" justifyContent="center" gap={1}  >
          {(latestSubscription === 1 || latestSubscription !== 1 && latestSubscription !== 2) && (
            <Button
              variant={activeButton === 'International' ? 'contained' : 'outlined'}
              color="primary"
              onClick={() => {
                setActiveButton('International');
                fetchSubscriptionPlans(1);
                setAdditionalUsers('');
                setAdditionalCompany('');
                setTotalPrice('0.00');
                setSelectedPlanId(1);
                setSelectedCurrency(233);
              }}
            >
              International

            </Button>)}

          {(latestSubscription === 2 || latestSubscription !== 1 && latestSubscription !== 2) && (
            <Button
              variant={activeButton === 'China' ? 'contained' : 'outlined'}
              color="primary"
              onClick={() => {
                setActiveButton('China');
                fetchSubscriptionPlans(2);
                setAdditionalUsers('');
                setAdditionalCompany('');
                setTotalPrice('0.00');
                setSelectedPlanId(2);
                setSelectedCurrency(45);
              }}
            >
              China
            </Button>
          )}
        </Box>
        <hr />
        <Box>
          {plans
            .filter((plan) => plan.title.toLowerCase().includes(subscriptionType))
            .map((plan, index) => (
              <Grid item xs={12} md={12} key={index}>
                <Container>
                  <Card variant='outlined'>
                    <Grid container spacing={1} justifyContent="flex-start">
                      <Grid item xs={12} md={8}>
                        <Box sx={{ p: 2 }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <ToggleButtonGroup
                              value={subscriptionType}
                              exclusive
                              onChange={handleSubscriptionTypeChange}
                              aria-label="subscription type"
                              sx={{ marginBottom: 1 }}
                            >
                              <ToggleButton
                                sx={toggleButtonStyle}
                                value="monthly" >
                                Monthly
                              </ToggleButton>
                              <ToggleButton value="yearly"
                                sx={toggleButtonStyle}
                              >
                                Yearly
                              </ToggleButton>
                            </ToggleButtonGroup>
                          </Box>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <Typography sx={{ fontWeight: "700", fontSize: "20px" }}>Price Estimate</Typography>
                          </Box>
                          <br />
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <Typography>Basic Subcription Fees
                              <Typography sx={{ fontSize: "10px", textAlign: 'right', flexGrow: 1, color: "#707070", lineHeight: "8px" }}>2 users and 1 Company Included*</Typography>
                            </Typography>
                            <Typography >Per {plan.planTime}</Typography>
                            <Typography sx={{ fontWeight: 'bold' }}>
                              {currencySymbol} {subscriptionType === "yearly" ? yearlyBasePrice.toFixed(2) : monthlyBasePrice.toFixed(2)}
                            </Typography>
                          </Box>
                          <br />
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 5, flexGrow: 1 }}>
                              <Typography>Users Subcription</Typography>
                              <Typography sx={{ fontWeight: 'bold' }}>{currencySymbol} {monthlyPerUserPrice}/user</Typography>
                              <Typography>x <input
                                type="number"
                                value={additionalUsers}
                                onChange={handleUserChange}
                                style={inputStyle}
                              /> users x {plan.planTime}</Typography>
                            </Box>
                            <Typography sx={{ fontWeight: 'bold' }}>{currencySymbol} {totalUserAmount.toFixed(2)}</Typography>
                          </Box>
                          <br />
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 5, flexGrow: 1 }}>
                              <Typography>Company Subcription</Typography>
                              <Typography sx={{ fontWeight: 'bold' }}>{currencySymbol} {companyPerMonth}/Com.</Typography>
                              <Typography>x <input
                                type="number"
                                value={additionalCompany}
                                onChange={handleCompanyChange}
                                style={inputStyle}
                              /> Comp. x  {plan.planTime}</Typography>
                            </Box>
                            <Typography sx={{ fontWeight: 'bold' }}>{currencySymbol} {totalCompanyAmount.toFixed(2)}</Typography>
                          </Box>
                          <br />
                          {subscriptionType === "yearly" && (
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 5, flexGrow: 1 }}>
                                <Typography>{plan.discountContant}</Typography>
                              </Box>
                              <Typography sx={{ fontWeight: 'bold' }}>{currencySymbol} {discountAmount.toFixed(2)}</Typography>
                            </Box>
                          )}
                          <br />
                          <Divider />
                          <br />
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <Typography> {plan.title} Total Subscription Amount</Typography>
                            <Typography sx={{ fontWeight: 'bold' }}>{currencySymbol} {Number(totalPrice).toFixed(2)}</Typography>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Card sx={{
                          height: "100%",
                          backgroundColor: "#E7F0FF",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: 2,
                        }}>
                          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <Typography sx={{ fontWeight: 'bold', color: '#007BFF', fontSize: "25px" }}>{currencySymbol} {Number(totalPrice).toFixed(2)} /{plan.title} </Typography>
                            <br />
                            <CustomButton
                              onClick={handlePayment}
                              variant="contained" color="primary" title="Buy Now" />
                            {isFirstTimeLogin && (
                              <Button
                                variant={"outlined"}
                                color="primary"
                                fullWidth
                                sx={{ mt: 2 }}
                                onClick={handleStartFreeTrail}
                              >
                                Skip & Start free Trial
                              </Button>
                            )}
                          </Box>
                        </Card>
                      </Grid>
                    </Grid>
                  </Card>
                </Container>
              </Grid>
            ))}
        </Box>
        <Dialog
          open={message.status}
          onClose={handleClose}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle sx={{ textAlign: "center", mt: 2 }}>
            {message?.type == "success" ? (
              <CheckCircleIcon sx={{ fontSize: 60, color: "green" }} />
            ) : (
              <ErrorOutlineIcon sx={{ fontSize: 60, color: "red" }} />
            )}
          </DialogTitle>
          <DialogContent>
            <Typography variant="h5" align="center" gutterBottom>
              {message?.type == "success"
                ? `Payment Successful!`
                : "payment failed."}
            </Typography>
            <Typography variant="body2" align="center" color="textSecondary">
              {message?.message}
            </Typography>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
            <Button variant="contained" color="primary" onClick={handleClose}>
              Done
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};


export default GeneratePaymentLink;

const inputStyle = {
  backgroundColor: "#e7effe",
  border: "1px solid #00acff",
  borderRadius: "4px",
  color: "#0f4ec2",
  fontWeight: 600,
  height: "20px",
  // margin: "20px",
  width: "70px",
};
const toggleButtonStyle = {
  padding: '6px',
  textTransform: 'capitalize',
  '&.Mui-selected': {
    backgroundColor: '#007BFF',
    color: 'white',
    '&:hover': {
      backgroundColor: '#007BFF',
    },
  },
};
